import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'qm-percentage-circle',
  templateUrl: './percentage-circle.component.html',
  styleUrls: ['./percentage-circle.component.scss']
})
export class PercentageCircleComponent implements OnChanges {
  // these should match the font-sizes in the CSS
  public static pixelSizes = {
    'small': 80,
    'normal': 120,
    'big': 240,
  };

  @Input()
  public value: number;

  @Input()
  private color: 'success' | 'warning' | 'danger' | 'primary' = 'primary';

  @Input()
  private size: 'big' | 'small' | 'normal' = 'normal';

  // CSS classes for the main element
  public classes: string[] = [];

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.value || changes.size || changes.color) {
      this.classes = [
        'p' + this.value.toFixed(0),
        this.size,
        this.color,
      ].filter(x => x);
    }
  }
}
